import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import cookie from 'js-cookie'

axios.defaults.paramsSerializer = (params) => qs.stringify(params, {arrayFormat: 'brackets'})

axios.interceptors.request.use(config => {
  config.headers['RedcatTenant'] = sessionStorage.getItem('tenantId')
  return config
})
axios.interceptors.request.use(
  config => {
    let token = cookie.get('token') || sessionStorage.getItem('appToken')
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    if (token && token !== '') {
      config.headers.Authorization = token
    }
    let ossUrl = sessionStorage.getItem('ossDownloadUrl') || ''
    config.withCredentials = !config.url.includes(ossUrl) // 请求阿里云时不配置携带cookie信息
    config.url = encodeURI(config.url)
    return config
  },
  err => {
    return Promise.reject(err)
  })

const vueAxios = {
  install () {
    Vue.$axios = axios
    Object.defineProperties(Vue.prototype, {
      $axios: {
        get () {
          return axios
        }
      }
    })
  }
}

export {vueAxios}
export default axios



// WEBPACK FOOTER //
// ./src/plugins/axios/index.js